import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  Typography,
  Chip,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import StatusChip from "@/components/table/chip";
import empty_state_regularisation from "@/assets/images/attendance/empty_state_regularisation.png";

const RegularizationAccordion = ({
  items,
  renderDetails,
  renderActions,
  containerSpacing,
  detailsGridProps,
  actionsGridProps,
  accordionProps,
  getTitle, // Function to get the title for each accordion item
  getChipLabel,
  getChipStyle,
  showChip,
  showActions,
}) => {
  
  const records = items?.data?.records || [];
  console.log("records", records);

  const renderEmptyState = () => (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        height="100%"
      >
        <img src={empty_state_regularisation} alt="empty_state_regularisation" />
        <Typography variant="h6">No Records Available</Typography>
      </Box>
    );

    if (!records.length) return renderEmptyState();

  // if (!records.length) {
  //   return <Typography>Records not available!</Typography>;
  // }

  return (
    <>
      {records?.map((item, index) => (
        <Accordion
          defaultExpanded={index === 0}
          key={item.index}
          style={{ boxShadow: "0px 3px 5px rgba(0, 0, 0, 0.2)" }}
          {...accordionProps}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            id={`panel-header-${index}`}
            aria-controls={`panel-content-${index}`}
          >
            <Grid container alignItems="center">
              <Grid item xs>
                <Typography variant="body1" fontWeight="bold">
                  {getTitle(item)}
                </Typography>
              </Grid>
              {showChip && (
                <Grid item>
                  <StatusChip
                    label={getChipLabel(item)}
                    size="small"
                    variant="outlined"
                    dotColor={getChipStyle ? getChipStyle(item).color : null}
                    sx={{
                      fontWeight: "bold",
                      color: getChipStyle ? getChipStyle(item).color : null,
                      borderColor: getChipStyle
                        ? getChipStyle(item).borderColor
                        : null,
                      backgroundColor: getChipStyle
                        ? getChipStyle(item).backgroundColor
                        : null,
                      borderRadius: "11,473.41px",
                    }}
                  />
                </Grid>
              )}
            </Grid>
          </AccordionSummary>
          <AccordionDetails sx={{ p: (theme) => theme.spacing(0, 6, 3, 6) }}>
            <Grid container spacing={containerSpacing}>
              <Grid item {...detailsGridProps}>
                {renderDetails(item)}
              </Grid>
              {showActions && (
                <Grid
                  item
                  {...actionsGridProps}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {renderActions(item)}
                </Grid>
              )}
            </Grid>
          </AccordionDetails>
        </Accordion>
      ))}
    </>
  );
};

export default RegularizationAccordion;
